<div class="property-card expanded d-flex flex-column">
    <div class="property-image-container">
        <img src="https://picsum.photos/200" alt="Property" class="property-image">
        <app-checkbox class="property-checkbox" />
        <div class="property-menu align-self-baseline">
            <button class="property-menu-button">...</button>
        </div>
    </div>
    <div class="property-details d-flex flex-column">
        <div class="property-id">#426121</div>
        <div class="property-title">Продава Апартамент</div>
        <div class="property-price">240 000лв, 120кв.м.</div>
        <div class="property-location">София, Център</div>
    </div>
</div>
